import { useSelector } from 'react-redux';
import { de, enUS } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import { selectAuth } from '../../../redux/store/userData/user/selectors';
import { parseLocale } from '../../../utils/locale';

const useDateLocale = (): Locale => {
  const user = useSelector(selectAuth) as { locale?: string } | null;
  return parseLocale(user?.locale ?? '') === 'de' ? de : enUS;
};

export default useDateLocale;
